import * as React from 'react';
import { Routes } from '../../../routes';
import { PageHeadingWidget } from '../../../widgets/page/PageHeadingWidget';
import { observer } from 'mobx-react';
import { OrgPageWidget } from '../../../widgets/page/OrgPageWidget';
import { DevelopersTableWidget } from './DeveloperTableWidget';

export const UsersPage: React.FC = observer(() => {
  return (
    <OrgPageWidget activeItemKey={Routes.MANAGE_USERS}>
      <PageHeadingWidget title={'Developers'} />
      <DevelopersTableWidget />
    </OrgPageWidget>
  );
});
